
import { onMounted, ref, computed, inject, nextTick } from 'vue'
import { getStatusBarInfo, getClientCommonMessage } from '@/utils/nativeFn'
import { compareVersion } from '@/utils/compareVersion'
import store from '@/store/index'
import ActionBar from '@/components/ActionBar/index.vue'
import QuestionDetail from '@/components/Aio/QueAnalysisTile.vue'
import { useRoute } from 'vue-router'
export default {
  name: 'QuestionAnalysis',
  props: {
    index: { type: Number, default: 0 },
    sourceLocation: { type: String, default: 'null_source' }
  },
  components: { ActionBar, QuestionDetail },
  emits: ['close'],
  setup(props, { emit }) {
    const $xesLog = inject('$xesLog') as any // 埋点
    const myAnswer = ref([])

    const { source_location: source } = useRoute().query
    const isWeekStudy = computed(() => source === 'itembank')

    const questionList = computed(() => {
      return store.getters['taskPaper/questionList']
    })
    const queResList = computed(() => {
      return store.getters['taskPaper/queResList']
    })
    const submitQestionMap = computed(() => {
      return store.getters['taskPaper/submitQestionMap']
    })
    const swipWrap = ref(null)
    const swipeBoxInner = ref(null)
    const page_name = 'test_ans'
    let { index, sourceLocation: source_location } = props
    let initialIndex = Number((index || '0') as string)
    const currentIndex = ref(initialIndex) // 当前正在展示的题目的index
    let statusBarHeight = ref(0) // 状态栏高度
    let actionBarHeight = ref(79) // 默认actionBar高度
    const showActionBar = ref(false) // 是否开启 actionBar 默认false, 版本大于 1.7.0开启
    let versionName = 0
    const actionBarInfo = computed(() => {
      // actionBar需要的参数
      if (isWeekStudy.value) {
        return { actionBarTitle: '答题解析' }
      } else {
        return {
          actionBarTitle: questionList.value.length
            ? `${currentIndex.value + 1}/${questionList.value.length}`
            : ''
        }
      }
    })
    // 获取状态栏高度
    const getStatusBarHeight = () => {
      getStatusBarInfo({}, (res) => {
        console.log('h5调用端上getStatusBarInfo', res) // app返回给前端的值
        statusBarHeight.value = res.height
        actionBarHeight.value = 44 + res.height || 35
      })
    }
    // 获取版本信息
    const getClientCommonMessageFn = () => {
      getClientCommonMessage({}, (res) => {
        versionName = res.service_version_name
        if (compareVersion(versionName, '1.8.0') !== -1) {
          // 初始化弹窗
          showActionBar.value = true
          // 获取状态栏高度 + 计算actionBar高度
          getStatusBarHeight()
        }
      })
    }
    const goBack = () => {
      document.title = '练习报告'
      testClickEvent({ back: 'back' })
      // 关闭题目解析弹框
      emit('close')
    }
    // 下一题
    const handleNext = () => {
      currentIndex.value =
        currentIndex.value === questionList.value.length - 1 ? 0 : currentIndex.value + 1
      scrollTop()
      testClickEvent({ check_more: 'next_exer' })
    }
    // 上一题
    const handlePrev = () => {
      if (currentIndex.value === 0) {
        return
      }
      currentIndex.value--
      scrollTop()
      testClickEvent({ check_more: 'pre_exer' })
    }
    // 回到顶部
    const scrollTop = () => {
      swipWrap.value.scrollTop = 0
    }
    const testClickEvent = (params) => {
      if (!isWeekStudy) {
        $xesLog.track(
          'test_ans_click',
          {
            page_name,
            biz_name: 'int_lear',
            event_type: 'click',
            ...params
          },
          () => {
            console.log('题目解析点击埋点成功')
          }
        )
      }
    }
    const preventDefaultEvent = () => {
      return false
    }
    onMounted(() => {
      getClientCommonMessageFn()
      nextTick(() => {
        nextTick(() => {
          // 在线答题pv埋点
          !isWeekStudy &&
            $xesLog.view(
              'online_test_pv',
              {
                page_name,
                source_location,
                biz_name: 'int_lear',
                event_type: 'pv'
              },
              () => {
                console.log('在线答题pv埋点成功')
              }
            )
        })
      })
    })
    return {
      actionBarInfo,
      actionBarHeight,
      questionList,
      currentIndex,
      swipeBoxInner,
      swipWrap,
      myAnswer,
      queResList,
      submitQestionMap,
      initialIndex,
      goBack,
      handleNext,
      handlePrev,
      isWeekStudy,
      scrollTop,
      testClickEvent,
      preventDefaultEvent,
      showActionBar,
      backIcon: require('../../assets/images/aio/aio_go_back_x.png')
    }
  }
}
